
 



 
 import {fs} from "Config/FsConfig";
 
    import ResetPasswordTokenRequest from 'Modules/Core/Scripts/AppServiceContract/ResetPasswordTokenRequest';

    import ChangePasswordUpdateRequest from 'Modules/Core/Scripts/AppServiceContract/ChangePasswordUpdateRequest';

    import ResetPasswordUpdateRequest from 'Modules/Core/Scripts/AppServiceContract/ResetPasswordUpdateRequest';

    import PasswordRequirementsDisplayData from 'Modules/Core/Scripts/AppServiceContract/PasswordRequirementsDisplayData';


    //module ChangePasswordAppService {
    class ChangePasswordAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/ChangePasswordAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/ChangePasswordAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/?email=${encodeURIComponent(email)}
    //public static RouteSendForgetPasswordEmail = (email: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ChangePasswordAppService/SendForgetPasswordEmail`;
    public RouteSendForgetPasswordEmail(email: string) : string {
        return this.ControllerUrl + "/"+"SendForgetPasswordEmail";
    }
    public SendForgetPasswordEmail(email: string): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteSendForgetPasswordEmail(email),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(email),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCheckToken = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ChangePasswordAppService/CheckToken`;
    public RouteCheckToken() : string {
        return this.ControllerUrl + "/"+"CheckToken";
    }
    public CheckToken(request: ResetPasswordTokenRequest): JQuery.jqXHR<boolean> {
        return $.ajax({
                url: this.RouteCheckToken(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteChangePassword = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ChangePasswordAppService/ChangePassword`;
    public RouteChangePassword() : string {
        return this.ControllerUrl + "/"+"ChangePassword";
    }
    public ChangePassword(request: ChangePasswordUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteChangePassword(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteResetPassword = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ChangePasswordAppService/ResetPassword`;
    public RouteResetPassword() : string {
        return this.ControllerUrl + "/"+"ResetPassword";
    }
    public ResetPassword(request: ResetPasswordUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteResetPassword(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteResetPasswordAdmin = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ChangePasswordAppService/ResetPasswordAdmin`;
    public RouteResetPasswordAdmin() : string {
        return this.ControllerUrl + "/"+"ResetPasswordAdmin";
    }
    public ResetPasswordAdmin(request: ResetPasswordUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteResetPasswordAdmin(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteLoadPasswordRequirementsData = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ChangePasswordAppService/LoadPasswordRequirementsData`;
    public RouteLoadPasswordRequirementsData() : string {
        return this.ControllerUrl + "/"+"LoadPasswordRequirementsData";
    }
    public LoadPasswordRequirementsData(): JQuery.jqXHR<PasswordRequirementsDisplayData> {
        return $.ajax({
                url: this.RouteLoadPasswordRequirementsData(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default ChangePasswordAppService;



